import { _ } from "libs";

import React, { Component } from "react";
import { Form, Field } from "react-final-form";
import ClubInput from "./clubInput";
import ClubItemMedium from "../items/club/medium";
import { Profile, ClubAutocompleteResult } from "../../types";

const ClubSelect = ({ input: { onChange, value, name }, onSelect, ...rest }) => {
	return <ClubInput onChange={onChange} value={value} onSelect={onSelect} />;
};

type Props = {
	onChange: Function;
	profile: Profile;
};

type State = {
	club: any | null;
};

export class ClubForm extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		let club = null;

		if (props.profile && props.profile.favorites && props.profile.favorites.length > 0) {
			club = props.profile.favorites[0].clubInfo;
		}

		this.state = {
			club,
		};
	}

	clearValue = () => {
		this.setState({ club: null });
	};

	onSelect = (club: ClubAutocompleteResult) => {
		this.setState({ club });
	};

	render() {
		return (
			<Form
				onSubmit={({ club }: { club: ClubAutocompleteResult }, mutators) => {
					this.props.onChange(club);
				}}
				initialValues={this.props.profile}
				render={({ handleSubmit, submitting, pristine, invalid, values }) => (
					<form onSubmit={handleSubmit}>
						{this.state.club !== null ? (
							<>
								<label>{_("onboarding.clubForm.club.label")}</label>
								<div className="cell standalone selectedClub">
									<div className="remove" onClick={this.clearValue} />
									<ClubItemMedium
										name={this.state.club.name}
										meta={this.state.club.city}
										photoUrl={this.state.club.photoUrl}
									/>
								</div>
								<p className="note">{_("onboarding.clubForm.club.description")}</p>
							</>
						) : (
							<Field name="club">
								{({ input, meta, ...rest }) => (
									<div className="field searchField searchFieldWithIcon autosuggestClub">
										<label>{_("onboarding.clubForm.club.label")}</label>
										<ClubSelect
											{...{ input, meta, ...rest }}
											placeholder={_("onboarding.clubForm.club.placeholder")}
											onSelect={this.onSelect}
										/>
										{meta.touched && meta.error && <span>{meta.error}</span>}
									</div>
								)}
							</Field>
						)}
						<div className="buttons">
							<button type="submit" className="button" disabled={submitting}>
								{_("continueBtn")}
							</button>
						</div>
					</form>
				)}
			/>
		);
	}
}

export default ClubForm;
